import { useState, useEffect, Fragment } from 'react';
import axios from '../../axios/axiosconf';
import Header from '../general/Header';
import Aside from '../general/Aside';
import Footer from '../general/Footer';
import Unauthorized from '../general/Unauthorized';
import Loading from '../general/Loading';
import { Link } from 'react-router-dom';

function ReporteDocumentosEgresos() {
    // Estados de autenticación y permisos
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(null);
    const [client, setClient] = useState({});

    // Estados de datos
    const [documentos, setDocumentos] = useState([]);
    const [totales, setTotales] = useState({
        total_documentos: 0,
        total_documentado: 0,
        total_pagado: 0,
        total_pendiente: 0
    });

    // Estados de filtros
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [proveedorFiltro, setProveedorFiltro] = useState('');
    const [estadoFiltro, setEstadoFiltro] = useState('');
    const [proveedores, setProveedores] = useState([]);

    // Estados de paginación
    const [paginaActual, setPaginaActual] = useState(1);
    const [totalPaginas, setTotalPaginas] = useState(1);
    const [totalRegistros, setTotalRegistros] = useState(0);

    // Estado de expansión
    const [documentoExpandido, setDocumentoExpandido] = useState(null);

    // Estado de carga
    const [loading, setLoading] = useState(false);

    // Obtener fecha de hace 30 días
    const getFechaHace30Dias = () => {
        const fecha = new Date();
        fecha.setDate(fecha.getDate() - 30);
        return fecha.toISOString().split('T')[0];
    };

    // Obtener fecha actual
    const getFechaActual = () => {
        return new Date().toISOString().split('T')[0];
    };

    useEffect(() => {
        let userdata = {};

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // Validación de permisos híbrida
        let tienePermiso = false;

        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission =>
                permission.slug === 'ver_reporte_documentos_egresos'
            );
        } else if (userdata.up && userdata.up.includes('ver_reporte_documentos_egresos')) {
            tienePermiso = true;
        }

        setHasPermission(tienePermiso);

        if (!tienePermiso) {
            return;
        }

        // Cargar cliente
        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.error('Error al cargar cliente:', error);
            });

        // Cargar proveedores para el filtro
        axios.get('/proveedores?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setProveedores(response.data);
                }
            })
            .catch(error => {
                console.error('Error al cargar proveedores:', error);
            });

        // Establecer fechas por defecto (último mes)
        setFechaInicio(getFechaHace30Dias());
        setFechaFin(getFechaActual());

    }, []);

    // Cargar documentos cuando cambian los filtros o la página
    useEffect(() => {
        if (loggedIn && hasPermission && fechaInicio && fechaFin) {
            cargarDocumentos();
        }
    }, [loggedIn, hasPermission, paginaActual]);

    const cargarDocumentos = () => {
        setLoading(true);

        let userdata = {};
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const params = {
            uid: userdata.user_id,
            fecha_inicio: fechaInicio,
            fecha_fin: fechaFin,
            page: paginaActual,
            per_page: 12
        };

        if (proveedorFiltro) {
            params.proveedor_id = proveedorFiltro;
        }

        if (estadoFiltro !== '') {
            params.estado = estadoFiltro;
        }

        axios.get('/reportes/documentos-egresos', { params })
            .then(response => {
                if (response.status === 200) {
                    setDocumentos(response.data.documentos || []);
                    setTotales(response.data.totales || {
                        total_documentos: 0,
                        total_documentado: 0,
                        total_pagado: 0,
                        total_pendiente: 0
                    });
                    setTotalPaginas(response.data.total_paginas || 1);
                    setTotalRegistros(response.data.total_registros || 0);
                }
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar documentos:', error);
                setLoading(false);
            });
    };

    const handleBuscar = (e) => {
        e.preventDefault();
        setPaginaActual(1);
        cargarDocumentos();
    };

    const handleLimpiar = () => {
        setFechaInicio(getFechaHace30Dias());
        setFechaFin(getFechaActual());
        setProveedorFiltro('');
        setEstadoFiltro('');
        setPaginaActual(1);
    };

    const handleExportarExcel = () => {
        let userdata = {};
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const params = new URLSearchParams({
            uid: userdata.user_id,
            fecha_inicio: fechaInicio,
            fecha_fin: fechaFin
        });

        if (proveedorFiltro) {
            params.append('proveedor_id', proveedorFiltro);
        }

        if (estadoFiltro !== '') {
            params.append('estado', estadoFiltro);
        }

        // Abrir en nueva ventana para descargar
        window.open(`${axios.defaults.baseURL}/reportes/documentos-egresos/exportar-excel?${params.toString()}`, '_blank');
    };

    const toggleDocumento = (documentoId) => {
        if (documentoExpandido === documentoId) {
            setDocumentoExpandido(null);
        } else {
            setDocumentoExpandido(documentoId);
        }
    };

    const formatearMoneda = (valor) => {
        return '$' + Number(valor).toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    };

    const formatearFecha = (fecha) => {
        if (!fecha) return '';
        const soloFecha = String(fecha).slice(0, 10);
        const partes = soloFecha.split('-');
        if (partes.length !== 3) return fecha;
        return `${partes[2]}/${partes[1]}/${partes[0]}`;
    };

    const getEstadoChipClass = (estado) => {
        const e = parseInt(estado, 10);
        switch (e) {
            case 0:
                return 'report-chip report-chip--warn';
            case 1:
                return 'report-chip report-chip--ok';
            case 2:
                return 'report-chip report-chip--bad';
            default:
                return 'report-chip report-chip--neutral';
        }
    };

    const getEgresoEstadoChipClass = (estado) => {
        return parseInt(estado, 10) === 0
            ? 'report-chip report-chip--ok'
            : 'report-chip report-chip--bad';
    };

    // Protección de ruta
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (!loggedIn || hasPermission === null) {
        return <Loading />;
    }

    return (
        <div className="hold-transition" style={{ fontSize: '13px' }}>
            <Header client={client} />
            <Aside client={client} activelink="reports" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/estadisticas">Reportes</Link></li>
                                    <li className="breadcrumb-item active">Documentos vs Egresos</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <h1 className="m-0">
                                    <i className="fas fa-file-alt mr-2"></i>
                                    Documentos Soporte vs Egresos
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>

                <section className="content">
                    <div className="container-fluid">

                        {/* Filtros */}
                        <div className="card report-fin-card">
                            <div className="card-header">
                                <h3 className="card-title">
                                    <i className="fas fa-filter mr-2"></i>
                                    Filtros
                                </h3>
                                <div className="card-tools">
                                    <button
                                        type="button"
                                        className="btn btn-outline-success btn-sm"
                                        onClick={handleExportarExcel}
                                        disabled={loading || documentos.length === 0}
                                        title="Exportar a Excel"
                                    >
                                        <i className="fas fa-file-excel mr-1"></i>
                                        Exportar Excel
                                    </button>
                                </div>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleBuscar}>
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Fecha Inicio</label>
                                                <input
                                                    type="date"
                                                    className="form-control form-control-sm"
                                                    value={fechaInicio}
                                                    onChange={(e) => setFechaInicio(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Fecha Fin</label>
                                                <input
                                                    type="date"
                                                    className="form-control form-control-sm"
                                                    value={fechaFin}
                                                    onChange={(e) => setFechaFin(e.target.value)}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Proveedor (Opcional)</label>
                                                <select
                                                    className="form-control form-control-sm"
                                                    value={proveedorFiltro}
                                                    onChange={(e) => setProveedorFiltro(e.target.value)}
                                                >
                                                    <option value="">Todos</option>
                                                    {proveedores.map(proveedor => (
                                                        <option key={proveedor.id} value={proveedor.id}>
                                                            {proveedor.nombre_proveedor}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Estado (Opcional)</label>
                                                <select
                                                    className="form-control form-control-sm"
                                                    value={estadoFiltro}
                                                    onChange={(e) => setEstadoFiltro(e.target.value)}
                                                >
                                                    <option value="">Todos</option>
                                                    <option value="0">Pendiente</option>
                                                    <option value="1">Enviado DIAN</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>&nbsp;</label>
                                                <div>
                                                    <button type="submit" className="btn btn-primary btn-sm btn-block mb-2" disabled={loading}>
                                                        <i className="fas fa-search mr-1"></i>
                                                        Buscar
                                                    </button>
                                                    <button type="button" className="btn btn-secondary btn-sm btn-block" onClick={handleLimpiar} disabled={loading}>
                                                        <i className="fas fa-eraser mr-1"></i>
                                                        Limpiar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>

                        {/* Cards de Totales */}
                        <div className="row">
                            <div className="col-md-3">
                                <div className="card card-outline card-secondary">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h3 className="mb-0">{totales.total_documentos}</h3>
                                                <p className="text-muted mb-0">Total Documentos</p>
                                            </div>
                                            <div className="report-fin-kpi-icon" style={{ background: 'rgba(108, 117, 125, 0.12)', color: '#6c757d' }}>
                                                <i className="fas fa-file-alt"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="card card-outline card-secondary">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h3 className="mb-0">{formatearMoneda(totales.total_documentado)}</h3>
                                                <p className="text-muted mb-0">Total Documentado</p>
                                            </div>
                                            <div className="report-fin-kpi-icon" style={{ background: 'rgba(23, 162, 184, 0.12)', color: '#17a2b8' }}>
                                                <i className="fas fa-dollar-sign"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="card card-outline card-success">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h3 className="mb-0">{formatearMoneda(totales.total_pagado)}</h3>
                                                <p className="text-muted mb-0">Total Pagado</p>
                                            </div>
                                            <div className="report-fin-kpi-icon" style={{ background: 'rgba(40, 167, 69, 0.10)', color: '#28a745' }}>
                                                <i className="fas fa-check-circle"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="card card-outline card-warning">
                                    <div className="card-body">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div>
                                                <h3 className="mb-0">{formatearMoneda(totales.total_pendiente)}</h3>
                                                <p className="text-muted mb-0">Total Pendiente</p>
                                            </div>
                                            <div className="report-fin-kpi-icon" style={{ background: 'rgba(250, 173, 20, 0.14)', color: '#d97706' }}>
                                                <i className="fas fa-clock"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Tabla de Documentos */}
                        <div className="card report-fin-card">
                            <div className="card-header">
                                <h3 className="card-title">
                                    <i className="fas fa-list mr-2"></i>
                                    Documentos Soporte ({totalRegistros})
                                </h3>
                            </div>
                            <div className="card-body p-0">
                                {loading ? (
                                    <div className="text-center py-5">
                                        <i className="fas fa-spinner fa-spin fa-2x text-primary"></i>
                                        <p className="mt-3 text-muted small">Cargando documentos...</p>
                                    </div>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table table-hover mb-0 report-fin-table">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '44px' }}></th>
                                                    <th>N° Documento</th>
                                                    <th>Fecha</th>
                                                    <th>Proveedor</th>
                                                    <th className="text-right">Total</th>
                                                    <th className="text-right">Pagado</th>
                                                    <th className="text-right">Pendiente</th>
                                                    <th>Estado</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {documentos.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="8" className="text-center py-4">
                                                            <i className="fas fa-inbox fa-2x text-muted mb-2 d-block"></i>
                                                            <p className="text-muted mb-0 small">No se encontraron documentos para el período seleccionado</p>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    documentos.map((item) => (
                                                        <Fragment key={item.documento.id}>
                                                            <tr
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() => toggleDocumento(item.documento.id)}
                                                            >
                                                                <td className="text-center">
                                                                    <i className={`fas fa-chevron-${documentoExpandido === item.documento.id ? 'down' : 'right'}`}></i>
                                                                </td>
                                                                <td><strong>{item.documento.numero_completo}</strong></td>
                                                                <td>{formatearFecha(item.documento.fecha_emision)}</td>
                                                                <td>{item.documento.proveedor_nombre}</td>
                                                                <td className="text-right">{formatearMoneda(item.documento.valor_total)}</td>
                                                                <td className="text-right text-success">{formatearMoneda(item.documento.valor_pagado)}</td>
                                                                <td className="text-right text-warning">{formatearMoneda(item.documento.saldo_pendiente)}</td>
                                                                <td>
                                                                    <span className={getEstadoChipClass(item.documento.estado)}>
                                                                        {item.documento.estado_texto}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                            {documentoExpandido === item.documento.id && item.egresos.length > 0 && (
                                                                <tr>
                                                                    <td colSpan="8" className="bg-light">
                                                                        <div className="p-3">
                                                                            <h6 className="mb-3 small font-weight-bold text-secondary">
                                                                                <i className="fas fa-money-bill-wave mr-2"></i>
                                                                                Egresos ({item.egresos.length})
                                                                            </h6>
                                                                            <table className="table table-sm table-bordered mb-0 report-fin-nested-table">
                                                                                <thead className="bg-white">
                                                                                    <tr>
                                                                                        <th>N° Egreso</th>
                                                                                        <th>Fecha</th>
                                                                                        <th className="text-right">Valor</th>
                                                                                        <th>Forma Pago</th>
                                                                                        <th>Estado</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {item.egresos.map((egreso) => (
                                                                                        <tr key={egreso.id}>
                                                                                            <td>{egreso.numero}</td>
                                                                                            <td>{formatearFecha(egreso.fecha_creacion)}</td>
                                                                                            <td className="text-right">{formatearMoneda(egreso.valor_total)}</td>
                                                                                            <td>{egreso.forma_pago_texto}</td>
                                                                                            <td>
                                                                                                <span className={getEgresoEstadoChipClass(egreso.estado)}>
                                                                                                    {egreso.estado_texto}
                                                                                                </span>
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                            {documentoExpandido === item.documento.id && item.egresos.length === 0 && (
                                                                <tr>
                                                                    <td colSpan="8" className="bg-light">
                                                                        <div className="p-3 text-center text-muted">
                                                                            <i className="fas fa-info-circle mr-2"></i>
                                                                            No hay egresos registrados para este documento
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </Fragment>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                            {totalPaginas > 1 && (
                                <div className="card-footer clearfix">
                                    <ul className="pagination pagination-sm m-0 float-right">
                                        <li className={`page-item ${paginaActual === 1 ? 'disabled' : ''}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setPaginaActual(paginaActual - 1)}
                                                disabled={paginaActual === 1}
                                            >
                                                «
                                            </button>
                                        </li>
                                        {[...Array(totalPaginas)].map((_, i) => (
                                            <li key={i} className={`page-item ${paginaActual === i + 1 ? 'active' : ''}`}>
                                                <button
                                                    className="page-link"
                                                    onClick={() => setPaginaActual(i + 1)}
                                                >
                                                    {i + 1}
                                                </button>
                                            </li>
                                        ))}
                                        <li className={`page-item ${paginaActual === totalPaginas ? 'disabled' : ''}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setPaginaActual(paginaActual + 1)}
                                                disabled={paginaActual === totalPaginas}
                                            >
                                                »
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            )}
                        </div>

                    </div>
                </section>
            </div>

            <Footer showToast={false} delay={0} />
        </div>
    );
}

export default ReporteDocumentosEgresos;
